module.exports = __webpack_public_path__ + "img/h1.4442acda.png";